var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import SyntaxHighlighter from "react-syntax-highlighter/dist/esm/prism-light";
import json from 'react-syntax-highlighter/dist/esm//languages/prism/json';
import prismStyles from 'react-syntax-highlighter/dist/esm/styles/prism/prism';
SyntaxHighlighter.registerLanguage('json', json);

export default (function (props) {
    return React.createElement(SyntaxHighlighter, _extends({ style: prismStyles }, props));
});